module.exports = __webpack_public_path__ + "static/media/july-youtube.0f5fa41b.jpg";